export default class EventConstants {
	public static readonly TRAITEMENT_FINISHED: string = "TRAITEMENT_FINISHED";
	public static readonly MODAL_IMPORTER_TOPAZE: string = "MODAL_IMPORTER_TOPAZE";
	public static readonly MODAL_CLOTURE_PAIE: string = "MODAL_CLOTURE_PAIE";
	public static readonly MODAL_VIREMENT_SEPA: string = "MODAL_VIREMENT_SEPA";
	public static readonly MODAL_DEVALIDATION_CLOTURE_EXERCICE: string = "MODAL_DEVALIDATION_CLOTURE_EXERCICE";
	public static readonly MODAL_ENVOI_BULLETIN: string = "MODAL_ENVOI_BULLETIN"
	public static readonly SOCIETE_CHANGED: string = "SOCIETE_CHANGED";
	public static readonly MODAL_ALERT: string = "MODAL_ALERT";
	public static readonly TAB_CLOSED: string = "TAB_CLOSED";
	public static readonly CLOSE_TAB: string = "CLOSE_TAB";
	public static readonly MANAGE_TAB_FROM_ROUTE: string = "MANAGE_TAB_FROM_ROUTE";
	public static readonly ETAT_SAISIE_CHANGED: string = "ETAT_SAISIE_CHANGED";
	public static readonly UTILISATEUR_CHANGED: string = "UTILISATEUR_CHANGED";
	public static readonly RELOAD_ACCUEIL: string = "RELOAD_ACCUEIL";
	public static readonly ALL_LISTES_LOADED: string = "ALL_LISTES_LOADED";
	public static readonly IS_PST_CHANGED: string = "IS_PST_CHANGED";
	public static readonly MODAL_ENQUETE_SATISFACTION: string = "MODAL_ENQUETE_SATISFACTION";
	public static readonly MODAL_EDITION_FIN_DE_MOIS: string = "MODAL_EDITION_FIN_DE_MOIS";
	public static readonly MODAL_EDITION_FIN_DE_MOIS_CUMULEES: string = "MODAL_EDITION_FIN_DE_MOIS_CUMULEES";
	public static readonly MODAL_REEDITION_BULLETINS: string = "MODAL_REEDITION_BULLETINS";
	public static readonly MODAL_SALARIES: string = "MODAL_SALARIES";
	public static readonly MODE_MANAGER_CHANGED: string = "MODE_MANAGER_CHANGED";
	public static readonly OPEN_AIDE_EN_LIGNE: string = "OPEN_AIDE_EN_LIGNE";
	public static readonly FEATURE_FLAG_LOADED: string = "FEATURE_FLAG_LOADED";
	public static readonly MENU_INITIALIZATION_COMPLETED: string = "MENU_INITIALIZATION_COMPLETED";
	public static readonly CHANGE_VALIDER_SAISIE_STATE: string = "CHANGE_VALIDER_SAISIE_STATE";
	public static readonly TRAITEMENT_EN_COURS: string = "TraitementEnCoursDto";
	public static readonly DSN_REFRESH_MODULE_AMORCAGE_TAUX_PAS: string = "DSN_REFRESH_MODULE_AMORCAGE_TAUX_PAS";
	public static readonly DSN_SELECTED_YEAR_CHANGE_AMORCAGE_TAUX_PAS: string = "DSN_SELECTED_YEAR_CHANGE_AMORCAGE_TAUX_PAS";
	public static readonly DSN_REFRESH_CURRENT_LIST_AMORCAGE_TAUX_PAS: string = "DSN_REFRESH_CURRENT_LIST_AMORCAGE_TAUX_PAS";
}

export class RoleConstants {
	public static readonly Administrateur: string = "Administrateur";
	public static readonly Payeur: string = "Payeur";
	public static readonly AdministrateurPST: string = "AdministrateurPST";
	public static readonly UtilisateurPST: string = "UtilisateurPST";
	public static readonly Salarie: string = "Salarie";
	public static readonly WithoutPaie: string = "WithoutPaie";
}



// WEBPACK FOOTER //
// ./src/components/Controls/EventConstants.ts